module.exports = __webpack_public_path__ + "static/p07_borregoR-77ff37ab0b4a2ede81b01f8ad5b178dc.png";